module.exports = __webpack_public_path__ + "static/media/strahovanie.aac0e18f.svg";